export default function CTASection() {
  return (
    <section className="py-20 md:py-28 px-6 md:px-10 bg-background-100">
      <div className="max-w-[1440px] mx-auto">
        <div className="max-w-3xl mx-auto text-center">
          <div className="rounded-2xl overflow-hidden mb-10">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20inviting%20product%20flat%20lay%20featuring%20curated%20fashion%20lifestyle%20items%20including%20sneakers%20bags%20sunglasses%20and%20accessories%20arranged%20organically%20on%20textured%20warm%20beige%20linen%20surface%2C%20soft%20natural%20diffused%20daylight%2C%20editorial%20ecommerce%20aesthetic%20with%20warm%20earthy%20tones%20and%20generous%20copy%20space&width=1200&height=600&seq=cta-bg-v2&orientation=landscape"
              alt="OOPBUY Spreadsheet Produktübersicht"
              className="w-full h-auto object-cover"
            />
          </div>

          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight mb-3">
            Bereit dein <span className="italic text-accent-500">OOPBUY Spreadsheet</span> zu entdecken?
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mb-8 max-w-lg mx-auto">
            Starte jetzt und finde die besten Produkte zu den günstigsten Preisen
          </p>

          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-block bg-primary-500 hover:bg-primary-600 text-white px-8 py-3.5 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap"
          >
            Jetzt OOPBUY Spreadsheet entdecken
          </a>
        </div>
      </div>
    </section>
  );
}